/** 检查报告的问题说明（中文）。占位符与 findings-en.ts 相同。 */
export default {
  FORMAT_UNSUPPORTED: '此文件不是受支持的图纸。请另存为 AutoCAD 2000（R2000）DWG 或 DXF。',
  READ_FAILED: '无法读取图纸。',
  LAYER_MISSING: '缺少必需图层 {{layer}}。',
  SITE_BOUNDARY_COUNT: '图层 {{layer}} 必须恰好包含一个场地边界；实际包含 {{count}} 个。',
  CHECK_SKIPPED: '已跳过需要场地边界的检查：{{checks}}。',
  BOUNDARY_NOT_CLOSED: '{{layer}} 上的场地边界存在 {{gap_m}} m 的缺口（容差 {{tolerance_m}} m）。',
  BLOCK_REFERENCE_PRESENT: '图层 {{layer}} 包含 {{count}} 个块参照，这是不允许的。',
  LAYER_HIDDEN: '必需图层 {{layer}} 处于隐藏状态（{{state}}）；仍已读取。',
  UNITS_SUSPECT: '场地跨度为 {{span_m}} m，超出 {{min_m}} 至 {{max_m}} m 的范围。请检查图纸单位。',
  OUTSIDE_JURISDICTION: '按 EPSG:{{srid}} 读取时，场地位于管辖范围之外。请检查坐标系。',
  JURISDICTION_NOT_CONFIGURED: '未配置管辖边界，因此未检查场地位置。',
  DATUM_AMBIGUOUS: 'EPSG:{{srid}} 容易与仅相差数米的相邻基准混淆。请确认坐标系。',
  GEOMETRY_REPAIRED: '已自动修复 {{count}} 个几何图形。',
  GEOMETRY_INVALID: '{{count}} 个几何图形无效且无法修复。',
  OUTSIDE_SITE_IGNORED: '已忽略场地外的 {{count}} 个要素（图框、图例、插图）。',
  BACKGROUND_FILL_DROPPED: '已删除覆盖场地的 {{count}} 个背景填充。',
  PLOT_EXCEEDS_SITE: '{{count}} 个地块超出场地边界（最大超出 {{max_overhang_m2}} m²）。',
  OVERLAP_RATE: '地块重叠 {{overlap_m2}} m²（占场地的 {{pct}}%）。',
  SLIVER_GAPS: '地块之间有 {{count}} 处细小缝隙（共 {{area_m2}} m²）。',
  UNASSIGNED_AREA: '场地中有 {{area_m2}} m² 未被任何地块覆盖；已归入 {{class}}。',
  LABEL_UNMATCHED: '{{count}} 个地块没有与土地用途代码表匹配的标注。',
  AREA_MISMATCH: '场地实测 {{site_m2}} m²，但申报为 {{declared_m2}} m²（相差 {{diff_pct}}%）。',
  UNKNOWN_LAYERS: '{{count}} 个图层不属于规划标准：{{layers}}。',
  Z_FLATTENED: '已舍弃高程；规划按二维读取。',
} as const
